<template>
    <transition name="modal">
        <div class="modal-mask">
        <div class="modal fade in" style="display: block; padding-right: 15px;">
            <div class="modal-dialog" v-bind:class="classObject">
                <div class="modal-content">
                    <div class="modal-header">
                        <slot name="header">
                        <button type="button" class="close" @click="$emit('close')">×</button>
                        <slot name="title">
                            <h5 class="modal-title">Header</h5>
                        </slot>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: ['size'],
  mounted () {
    this.$emit('shown')
  },
  computed: {
    classObject: function () {
      let co = {}
      let sz = this.size ? this.size : 'sm'
      co['modal-' + sz] = true
      return co
    }
  }
}

</script>

<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal {
        transition: all .3s ease;
        display: block;
        position: absolute !important;
    }

    .modal-footer {
        text-align: right;
    }

    .modal-body {
        max-height: calc(100vh - 210px);
        overflow-y: auto;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal,
    .modal-leave-active .modal {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
